import { inject, Injectable } from '@angular/core'
import { environment as ENV } from '../../../environments/environment'
import { ApiResponse } from 'src/app/api/model/api.model'
import { catchAndHandleError, mapToMaybeData } from 'src/app/api/util'
import {
  CodelistMapping,
  SageLinkAdeptMarketSubmissionResponse,
  SageLinkPreviousMarkets,
  STMSageLinkDisplayResponse,
  STMSageLinkReinsurerPartyMapping,
} from '../models/submit-to-market-sage-link.model'
import { HttpClient } from '@angular/common/http'

const SAGE_LINK_URL = `${ENV.internalApi.base}${ENV.internalApi.submitToMarket}`

const API = ENV.internalApi

@Injectable({
  providedIn: 'root',
})
export class SageLinkService {
  private http = inject(HttpClient)

  postAdeptSubmitToMarket(
    draftId: number,
    submissionDetailsList: STMSageLinkDisplayResponse[],
  ): ApiResponse<string> {
    const url = `${SAGE_LINK_URL}/drafts/${draftId}/adept-sage-link-submit-market`
    return this.http
      .post<string>(url, submissionDetailsList)
      .pipe(mapToMaybeData(), catchAndHandleError('Post Adept Submit to Market Failed', {}))
  }
  getSageLinkResponseFromProcessID(
    processID: string,
  ): ApiResponse<SageLinkAdeptMarketSubmissionResponse[]> {
    const url = `${SAGE_LINK_URL}/drafts/adept-sage-link-submit-market/${processID}`
    return this.http
      .get<SageLinkAdeptMarketSubmissionResponse[]>(url)
      .pipe(mapToMaybeData(), catchAndHandleError('Get Results From Process ID Failed', {}))
  }

  fetchSTMSageLinkReinsurersPartyMapping(): ApiResponse<STMSageLinkReinsurerPartyMapping[]> {
    const url = `${ENV.internalApi.base}/sagelink-party-mapping`
    return this.http
      .get<STMSageLinkReinsurerPartyMapping[]>(url)
      .pipe(
        mapToMaybeData(),
        catchAndHandleError('Get STM SageLink Reinsurers Party Mapping Failed'),
      )
  }

  getCodeMappingListData(): ApiResponse<CodelistMapping[]> {
    const endpoint = `${ENV.internalApi.base}${API.sageLinkCodeMapping}`
    return this.http
      .get<CodelistMapping[]>(endpoint)
      .pipe(mapToMaybeData(), catchAndHandleError('Get Code Mapping List Failed'))
  }

  getPreviousMarketsData(
    draftId: number,
    layerRefs: string,
  ): ApiResponse<SageLinkPreviousMarkets[]> {
    const endpoint = `${SAGE_LINK_URL}/drafts/${draftId}/previous-markets`
    return this.http
      .get<SageLinkPreviousMarkets[]>(endpoint, {
        params: {
          layerRefs,
        },
      })
      .pipe(mapToMaybeData(), catchAndHandleError('Get Previous Markets Failed'))
  }
}
